import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material';

import { FormLabel, MenuItem, Select, Stack, Text } from 'shell/components';

const RankingQuestion = ({ question, itemList, defaultItem, review, setCanSubmit, handleSelected }) => {
    const rankingOptions = [
        { key: '', value: 'Select' },
        ...itemList.map((_, index) => ({ key: (index + 1).toString(), value: (index + 1).toString() })),
    ];

    const [values, setValues] = useState(Object.values(itemList).reduce((acc, cur) => ({ ...acc, [cur.key]: '' }), {}));
    const [errors, setErrors] = useState(Object.values(itemList).reduce((acc, cur) => ({ ...acc, [cur.key]: '' }), {}));

    const handleChange = (key, value) => {
        setValues((current) => {
            const newValues = {
                ...current,
                [key]: value,
            };
            handleSelected(
                itemList.map((option) => {
                    return {
                        key: option.key,
                        value: newValues[option.key],
                    };
                })
            );
            return newValues;
        });
    };

    const renderRankings = () => {
        return itemList?.map(({ key, value }) => {
            return (
                <Stack key={key} alignItems={'center'} direction={'row'} justifyContent={'space-between'} spacing={2}>
                    <CustomFormLabel id={`${key}-label`} variant={'p2'}>
                        {value}
                    </CustomFormLabel>
                    <CustomSelect
                        aria-labelledby={key}
                        disabled={review}
                        displayEmpty
                        error={Boolean(errors[key])}
                        value={values[key]}
                        onChange={(e) => handleChange(key, e.target.value)}
                    >
                        {rankingOptions.map(({ key, value }) => (
                            <MenuItem key={key} value={key}>
                                {value}
                            </MenuItem>
                        ))}
                    </CustomSelect>
                </Stack>
            );
        });
    };

    useEffect(() => {
        if (defaultItem) setValues(defaultItem.reduce((acc, cur) => ({ ...acc, [cur.key]: cur.value }), {}));
    }, [defaultItem]);

    // validate against duplicate rankings
    useEffect(() => {
        Object.entries(values).forEach(([key, value]) => {
            const dupes = Object.values(values).filter((zoo) => {
                return value && value === zoo;
            });
            setErrors((current) => {
                return {
                    ...current,
                    [key]: dupes.length > 1 ? 'Please select a different option' : '',
                };
            });
        });
    }, [values]);

    useEffect(() => {
        const hasError = Object.values(errors).reduce((acc, cur) => {
            return acc || Boolean(cur);
        }, false);
        setCanSubmit(!hasError);
    }, [errors]);

    return (
        <Stack spacing={2}>
            <Text sx={{ hyphens: 'unset' }} variant={'p2'}>
                {question}
            </Text>
            {renderRankings()}
        </Stack>
    );
};

const CustomFormLabel = styled(FormLabel)(({ theme }) => {
    return {
        color: theme.palette.ensightful.neutral[900],
    };
});

const CustomSelect = styled(Select)(() => {
    return {
        width: '50%',
    };
});

export default RankingQuestion;
